module.exports = __webpack_public_path__ + "public/images/logo-pt.3edbe02509313979443f6231c30112e3.svg";